import styled from '@emotion/styled';
import {
  Box,
  Button,
  Dialog,
  DialogContent,
  Typography,
  useMediaQuery,
  useTheme,
  Snackbar,
  Alert
} from '@mui/material';
import React, { useEffect, useState } from 'react';
import mobileSS from '../assets/mobile-ss.png';
import playStore from '../assets/googlestore.png';
import appStore from '../assets/as.png';
import close from '../assets/backBtn.png';

const StyledDialog = styled(Dialog)<{ dialogWidth: string; dialogHeight: string }>(({ dialogWidth, dialogHeight }) => ({
  '& .MuiDialog-container': {
    backdropFilter: 'blur(7px)'
  },
  '& .MuiDialog-paper': {
    borderRadius: '20px',
    backdropFilter: 'blur(120px)',
    boxShadow: '0 8px 32px 0 rgba(31, 38, 135, 0.37)',
    width: dialogWidth,
    maxWidth: 'none',
    height: dialogHeight,
    backgroundColor: 'rgba(255, 255, 255, 0.8)'
  },
  '& .MuiDialogContent-root': {
    padding: 0,
    color: 'none'
  }
}));

interface DownloadAppProps {
  openDialog: boolean;
  setOpenDialog: React.Dispatch<React.SetStateAction<boolean>>;
}

const DownloadPrompt: React.FC<DownloadAppProps> = ({ openDialog, setOpenDialog }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const dialogWidth = isMobile ? '85%' : '60%';
  const dialogHeight = isMobile ? '87%' : '80%';
  const [showComingSoon, setShowComingSoon] = React.useState(false);
  const [delayedShow, setDelayedShow] = useState(false);
  const handleClose = () => setOpenDialog(false);

  useEffect(() => {
    let timer: ReturnType<typeof setTimeout>;

    if (showComingSoon) {
      setDelayedShow(true); // Show immediately

      // Hide after 5 seconds
      timer = setTimeout(() => {
        setDelayedShow(false);
        setShowComingSoon(false); // Reset so it can show again on future clicks
      }, 3000);
    }

    return () => clearTimeout(timer);
  }, [showComingSoon]);

  return (
    <StyledDialog open={openDialog} dialogWidth={dialogWidth} dialogHeight={dialogHeight}>
      <DialogContent>
        <Box
          style={{
            display: 'flex',
            flexDirection: isMobile ? 'column' : 'row',
            alignItems: 'center',
            justifyContent: 'center',
            position: 'relative'
          }}>
          {/* Close Button */}
          <Box onClick={handleClose} style={{ position: 'absolute', top: 22, left: 15, cursor: 'pointer', zIndex: 2 }}>
            <img
              src={close}
              alt="close"
              style={{
                width: 30,
                height: 30,
                background: 'black',
                borderRadius: 20,
                paddingLeft: 5,
                marginTop: -5
              }}
            />
          </Box>

          {/* Left Section (Image for Desktop) */}
          {!isMobile && (
            <Box style={{ width: '50%', marginLeft: '3%', marginTop: '5%' }}>
              <img src={mobileSS} alt="mobile-screenshot" style={{ height: 450, width: 300 }} />
            </Box>
          )}

          {/* Right Section (Text + Buttons) */}
          <Box
            style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              textAlign: 'center',
              marginTop: isMobile ? '15%' : 0,
              padding: '0 20px'
            }}>
            <Typography
              style={{
                background:
                  'linear-gradient(89.92deg, #E02780 0.07%, #FF5D83 0.08%, #B465FF 38.02%, #FF9D32 62.98%, #FF7A52 83.45%, #FF4FF1 99.93%)',
                WebkitBackgroundClip: 'text',
                WebkitTextFillColor: 'transparent',
                fontWeight: 600,
                fontSize: isMobile ? 23 : 32,
                fontFamily: 'Baloo2'
              }}>
              Download Mobile App
            </Typography>
            <Typography
              style={{
                fontWeight: 500,
                fontSize: isMobile ? 15 : 23,
                fontFamily: 'Baloo2',
                color: 'rgba(31, 29, 58, 0.8)',
                marginTop: 10
              }}>
              Discover more functionalities and explore additional features with our mobile app, now available on
              stores. Download and enhance your experience today!
            </Typography>
            {delayedShow && (
              <Box
                sx={{
                  backgroundColor: 'Black',
                  color: 'white',
                  margin: '3px',
                  marginLeft: '173px',
                  padding: '8px 15px',
                  border: '1px white',
                  borderRadius: '10px',
                  fontSize: { xs: '12px', md: '21px' },
                  fontFamily: 'Baloo2',
                  fontWeight: '800',
                  whiteSpace: 'nowrap',
                  zIndex: 10,
                  boxShadow: '0px 2px 6px rgba(0, 0, 0, 0.2)'
                }}>
                Coming Soon
              </Box>
            )}
            <Box style={{ display: 'flex', gap: 50, margin: '20px 0' }}>
              <a
                href="https://play.google.com/store/apps/details?id=com.champsverse.kidsapp"
                target="_blank"
                rel="noopener noreferrer">
                <img src={playStore} alt="play-store" style={{ height: 27, width: 115, cursor: 'pointer' }} />
              </a>
              <Button onClick={() => setShowComingSoon(true)} style={{ padding: 0, minWidth: 0 }}>
                <img src={appStore} alt="app-store" style={{ height: 27, width: 115, cursor: 'pointer' }} />
              </Button>
            </Box>

            {/* Image below content for Mobile */}
            {isMobile && (
              <Box style={{ marginTop: 10 }}>
                <img src={mobileSS} alt="mobile-screenshot" style={{ width: 150 }} />
              </Box>
            )}
          </Box>
        </Box>
      </DialogContent>
    </StyledDialog>
  );
};

export default DownloadPrompt;
